import { useState, useEffect } from 'react';

/**
 * Custom hook to detect if a media query matches.
 * 
 * @param query - The media query string (e.g., '(max-width: 991px)')
 * @returns boolean - Whether the query matches
 */
export const useMediaQuery = (query: string): boolean => {
    const [matches, setMatches] = useState<boolean>(false);

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const mediaQuery = window.matchMedia(query);
        
        // Use an initial check
        setMatches(mediaQuery.matches);

        const handler = (event: MediaQueryListEvent) => setMatches(event.matches);
        
        mediaQuery.addEventListener('change', handler);
        return () => mediaQuery.removeEventListener('change', handler);
    }, [query]);

    return matches;
};
